<template>
  <div class="sip-verification" :aria-busy="offer.verifying">
    <div v-if="offer.isVerified(cart.sessionId)" class="sip-verification__success" role="status">
      <strong>Cheers! Your 30% off is unlocked.</strong>
      <p>Thanks for sharing your Banjino’s moment. Your discount will apply automatically at checkout.</p>
      <a v-if="offer.verification.postUrl" :href="offer.verification.postUrl" target="_blank" rel="noopener noreferrer">View your post ↗</a>
    </div>
    <template v-else-if="offer.rewardToken">
      <p class="sip-verification__title">{{ offer.verifying ? 'Unlocking your reward…' : 'Your First Sip reward' }}</p>
      <BrandButton :loading="offer.verifying" :disabled="offer.verifying" @click="claim">{{ offer.verificationError ? 'Try my reward again' : 'Unlock my 30% off' }}</BrandButton>
    </template>
    <template v-else>
      <p class="sip-verification__title">Your next step: share your sip.</p>
      <p>Use a public account so we can check your tag.</p>
      <a class="bj-btn bj-btn--burgundy" href="https://ig.me/m/drinkbanjinos" target="_blank" rel="noopener noreferrer">Message us SIP on Instagram ↗</a>
      <p class="sip-verification__hint">Already posted? Check your Instagram DMs and message requests. If your photo or Reel is new, wait a minute and send SIP again. Private posts can’t be checked automatically.</p>
    </template>
    <p v-if="offer.verificationError || offer.linkError" class="sip-verification__error" role="alert">{{ offer.verificationError || offer.linkError }}</p>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import { useOfferStore } from '@/stores/offer'
import { useCartStore } from '@/stores/cart'
import BrandButton from './BrandButton.vue'
const offer = useOfferStore()
const cart = useCartStore()
async function claim() {
  await cart.ready
  await cart.ensureSession()
  await offer.claimReward(cart.sessionId)
}
watch(() => [cart.sessionId, offer.rewardToken], () => { if (offer.active && offer.rewardToken) claim() }, { immediate: true })
</script>

<style scoped>
.sip-verification { min-width: 0; font: 15px/1.6 var(--bj-font-ui); color: var(--bj-green-dark); overflow-wrap: anywhere; }
.sip-verification__title { font-weight: 700; font-size: 18px; }
.sip-verification p { margin: 12px 0; }
.sip-verification a { color: var(--bj-green); text-decoration: underline; text-underline-offset: 3px; }
.sip-verification a.bj-btn { color: white; text-decoration: none; }
.sip-verification__hint { font-size: 13px; }
.sip-verification__error { color: var(--bj-burgundy); }
.sip-verification__success { padding: 16px; background: color-mix(in srgb, var(--bj-green) 8%, var(--bj-bg)); border: 1px solid var(--bj-green); }
.sip-verification__success strong { font-size: 18px; }
.sip-verification .bj-btn { padding-inline: 24px; white-space: normal; }
</style>
